import { createStore } from 'vuex'

import global from './modules/global'
import auth from './modules/auth'
import menus from './modules/menus'
import sidebar from './modules/sidebar'
import map from './modules/map'
import geo from './modules/geo'
import poi from './modules/poi'
import kapal from './modules/kapal'
import history from './modules/history'
import users from './modules/users'
import plotting from './modules/plotting'
import tools from './modules/tools'
import reports from './modules/reports'
import zones from './modules/zones'

const store = createStore({
  modules: {
    global,
    auth,
    menus,
    sidebar,
    map,
    geo,
    poi,
    kapal,
    history,
    users,
    plotting,
    tools,
    reports,
    zones
  }
})

export default store;
